import React, { useState } from 'react';
import { Modal, Backdrop, Fade, Typography, Button, Divider } from '@material-ui/core';
import IconButton, { IconButtons } from '../../components/Buttons/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import color from '../../assets/css/colors';
import fontFamily from '../../assets/css/fonts';
import Text from '../../components/Typography/Text';
import CloseButton from '../../components/Buttons/CloseButton';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 1500,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& div:nth-child(1)': {
      flex: 1,
    },
    '& div:nth-child(2)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 30px',
    maxHeight: 600,
    overflowY: 'auto',
    fontFamily: fontFamily.headers,
    color: color.default.main,
    '& p': {
      fontSize: 16,
      fontFamily: fontFamily.headers,
      fontWeight: 400,
      lineHeight: '26px',
      color: color.default.main,
      marginTop: 0,
    },
    '& hr': {
      margin: '30px 0px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: 25,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 'auto',
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-4px !important',
    },
  },
  paper: {
    position: 'absolute',
  },
}));

export default function BaseModal({
  size, // Sm, Md, Lg, Full
  enableBackdropClose,
  open,
  onClose,
  title,
  children,
  infoSection,
  addOnButtonsSection,
  disableClose,
  addOnHeaderButtonsSection,
}) {
  const classes = useStyles();

  const handleClose = () => {
    if (!disableClose) {
      onClose();
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <div style={{ width: 1500 }}>
          <div style={{ width: 1500 }}>
            <div className={classes.modalHeader}>
              <div>
                <Text mt={3} variant="h2" label={title} />
              </div>
              <div>
                <IconButtons>
                  {addOnHeaderButtonsSection?.map((i, index) => {
                    return (
                      <div
                        style={{
                          marginLeft: 5,
                        }}
                        key={index}
                      >
                        {i}
                      </div>
                    );
                  })}
                  <IconButton
                    icon="close"
                    text="Close Modal"
                    onClick={handleClose}
                    disabled={disableClose}
                    color="inherit"
                  />
                </IconButtons>
              </div>
            </div>
            <div className={classes.modalBody}>
              <div style={{ width: '100%', padding: '30px 0px' }}>{children}</div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <div
              style={{
                display: 'flex',
                alignItems: 'end',
                justifyContent: 'space-between',
                flexGrow: 1,
                marginTop: 10,
              }}
            >
              <div
                style={{
                  color: 'orange',
                }}
              >
                {infoSection}
              </div>
              <div
                style={{
                  display: 'flex',
                  marginRight: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                  disabled={disableClose}
                >
                  Close
                </Button>

                {addOnButtonsSection?.map((i, index) => {
                  return (
                    <div
                      style={{
                        marginLeft: 5,
                      }}
                      key={index}
                    >
                      {i}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
